import { BLAdminWithPermissions } from '@/connection/access/get-channel-access';
import { Access, UserAccess } from '@/access/access';

export const requestDataToUserAccess = (user: BLAdminWithPermissions) =>
  new UserAccess(
    user.email,
    user.user_access.map((access) => Access.fromPermissionStatement(access)),
    user
  );
